class HeaderScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.theme.safeZone = 500

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 50
    this.safeZone = window.theme.safeZone
    this.scrollDirection = ''
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    document.body.classList.toggle(
      this.dataset.classScrolled,
      this.headerIsScrolled,
    )
  }

  get shouldBeVisible () {
    if (this.lastKnownY <= this.safeZone) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get headerIsScrolled () {
    return this.lastKnownY > this.offsetHeight + 40
  }
}

if (!customElements.get('header-scroll')) {
  customElements.define('header-scroll', HeaderScroll)
}
